(function () {
  'use strict';

  function initWarrantyPage(root) {
    root.querySelectorAll('.warranty-faq__item button[aria-controls]').forEach(function (button) {
      var panel = document.getElementById(button.getAttribute('aria-controls'));
      if (!panel) return;

      function close() {
        button.setAttribute('aria-expanded', 'false');
        panel.hidden = true;
      }

      button.addEventListener('click', function () {
        var willOpen = button.getAttribute('aria-expanded') !== 'true';
        root.querySelectorAll('.warranty-faq__item button[aria-expanded="true"]').forEach(function (openButton) {
          if (openButton !== button) {
            openButton.setAttribute('aria-expanded', 'false');
            var openPanel = document.getElementById(openButton.getAttribute('aria-controls'));
            if (openPanel) openPanel.hidden = true;
          }
        });
        button.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
        panel.hidden = !willOpen;
      });

      button.addEventListener('keydown', function (event) {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          button.click();
          return;
        }

        if (event.key === 'Escape' && button.getAttribute('aria-expanded') === 'true') {
          event.preventDefault();
          close();
          button.focus();
        }
      });
    });
  }

  function boot() {
    document.querySelectorAll('[data-warranty-page]').forEach(initWarrantyPage);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
}());
